import React, {useEffect, useState} from 'react';
import { TextField } from '@mui/material';
import _ from 'lodash';
import AgyleTextField from '../../components/ui/fields/agyleTextField';

function TextFieldDebounce(props) {
	const [textValue, setTextValue] = useState(!!props.value ? props.value : '');
	const {fullEvent, changeValueTrigger, ...others} = props;
	const propsCopy = _.cloneDeep(others);

	const TextComponent = props.agyleRefresh ? AgyleTextField : TextField;

    delete propsCopy.value;
	delete propsCopy.onChange;

	useEffect(() => {
		if (changeValueTrigger) {
			setTextValue(props.value);
		}
	}, [props.value]);

	return (
		<TextComponent
			{...propsCopy}
			value={textValue}
			onChange={(event) => {
				setTextValue(event.target.value);
				if (props.onChange) {
					props.onChange(event);
				}
			}}
			onBlur = {(event)=> {
				if (fullEvent) {
					props.onChange(event);
				} else {
					props.onChange({ target: { value: textValue }});
				}
			}}
		/>
	);
}

export  {TextFieldDebounce};
